import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-hr-menu',
    templateUrl: './hr-menu.component.html',
    styleUrls: ['./hr-menu.component.css'],
})
export class HrMenuComponent {
    /**
     * The name of the human resources webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
